/*
 * @Description:
 * @LastEditTime: 2023-08-28 11:17:26
 * @LastEditors: ai
 * @Author: ai
 * @Date: 2022-12-29 10:10:25
 */
import Vue from "vue";
import App from "./App.vue";
import htmlToPdf from "@/utils/htmlToPdf";
import VueDragResize from "vue-drag-resize";
import SignCanvas from "sign-canvas";
import "amfe-flexible";
import moment from "moment";
import router from "./router/index";
import toast from "@/components/Toast";
moment.locale("zh-cn"); // 汉化
Vue.use(htmlToPdf);
Vue.use(SignCanvas);
Vue.use(toast);
Vue.config.productionTip = false;
Vue.component("vue-drag-resize", VueDragResize);
let app = new Vue({
  router,
  render: (h) => h(App),
});
app.$mount("#app");
